import { render, staticRenderFns } from "./AiImages.vue?vue&type=template&id=2642627a&scoped=true&"
import script from "./AiImages.vue?vue&type=script&lang=js&"
export * from "./AiImages.vue?vue&type=script&lang=js&"
import style0 from "./AiImages.vue?vue&type=style&index=0&id=2642627a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2642627a",
  null
  
)

export default component.exports